//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Advancelist.js";
import { tolocalestringnumber } from "../computing/tolocalestringnumber";
import unity from "@/unity/unity";
const moment = require("moment");

export default {
  name: "advance-list",
  data(vm) {
    return {
      sortBy: "dateshow",
      sortDesc: true,
      page: 1,
      itemsPerPage: 10,
      pagination: {},
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_status: "",
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dataAll: [],
      status: ["Draft", "Request", "Approve", "Reject"],
      datefrom: null,
      dateto: null,
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      defaultlanguage: "en",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb" },
        { name: "th", flag: "th" },
      ],
      aa: "สวัสดี",
      dialogEdit: false,
      dialogDelete: false,
      mDataArray: [],
      position: [],
      approver: [],
      department: [],
      department_list: [],
      position_list: [],
      company: [],
      authorize: [],
      headers: [
        {
          text: "DATE",
          value: "dateshow",
          sort: (a, b) => new Date(a) - new Date(b),
        },
        { text: "DAY", value: "day", sortable: false },
        { text: "STATUS", value: "status_label", sortable: false },
        { text: "CHECK IN", value: "check_in", sortable: false },
        { text: "CHECK OUT", value: "check_out", sortable: false },
        { text: "WORKING HOURS", value: "working_hours", sortable: false },
        { text: "LOCATION ON CHECK IN", value: "location", sortable: false },
      ],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      jobTitle_list: [],
      searchCharge: null,
      searchChargeJob: null,
      searchEmp: [],
      delete_id: 0,
      dialogDeleteActivity: false,
    };
  },

  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.initialize();
  },
  components: {
    SuccessDialog,
  },
  beforeUpdate() { },
  computed: {
    // แปลงข้อมูลเดิมจาก API ให้มีคอลัมน์ตาม UI ใหม่ (ไม่แก้ข้อมูลต้นฉบับ)
    rows() {
      return (this.mDataArray || []).map((item) => {
        const times = this.extractTimes(item.timeshow);
        const checkIn = times[0] || null;
        const checkOut = times.length > 1 ? times[times.length - 1] : null;
        return {
          ...item,
          day: this.dayName(item.dateshow),
          status_label: item.statusshow || "No record",
          check_in: checkIn || "--:--",
          check_out: checkOut || "--:--",
          working_hours: this.workingHours(checkIn, checkOut),
        };
      });
    },
    rangeText() {
      const p = this.pagination;
      if (!p || !p.itemsLength) return "0 of 0";
      return `${p.pageStart + 1}–${p.pageStop} of ${p.itemsLength}`;
    },
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);
    // await this.loadCompanyMaster(comp_id);
    // await this.loadDepartmentMaster(comp_id);
    // await this.loadPositionMaster(comp_id);

    await this.loadAuthorize();
    await this.setStartAndEndOfMonth();

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
  },
  methods: {
    dayName(d) {
      const m = moment(d, ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY", moment.ISO_8601]);
      return m.isValid() ? m.format("ddd") : "-";
    },
    // ดึงเวลา HH:mm จากข้อความ timeshow เดิม (เวลาแรก = เข้า, เวลาสุดท้าย = ออก)
    extractTimes(text) {
      if (!text) return [];
      const found = String(text).match(/\b([01]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?\b/g) || [];
      return found.map((t) => t.substr(0, 5).padStart(5, "0"));
    },
    workingHours(inT, outT) {
      if (!inT || !outT) return "-";
      const [h1, m1] = inT.split(":").map(Number);
      const [h2, m2] = outT.split(":").map(Number);
      let mins = h2 * 60 + m2 - (h1 * 60 + m1);
      if (mins <= 0) return "-";
      return `${Math.floor(mins / 60)}h ${String(mins % 60).padStart(2, "0")}m`;
    },
    statusClass(s) {
      const v = String(s || "").toLowerCase();
      if (v.includes("no record")) return "ta-chip--grey";
      if (v.includes("late")) return "ta-chip--orange";
      if (v.includes("absent") || v.includes("missing")) return "ta-chip--red";
      if (v.includes("leave") || v.includes("holiday")) return "ta-chip--blue";
      return "ta-chip--green";
    },
    async clearSearch() {
      this.search = "";
      this.page = 1;
      this.$showLoader();
      await this.setStartAndEndOfMonth();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setStartAndEndOfMonth() {
      const today = new Date();

      // วันที่ 1 ของเดือนนี้
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.datefrom = moment(startOfMonth).format("YYYY-MM-DD");

      // วันที่สุดท้ายของเดือนนี้
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.dateto = moment(endOfMonth).format("YYYY-MM-DD");

      await this.loaddata();
    },
    async loadAuthorize() {
      const res_get = await api.getSettingGroupMenu();
      // console.log("res loadAuthorize : ", JSON.stringify(res_get));
      this.authorize = res_get.data;
    },

    async loaddata() {
      const resData = await api.getAllCheckInOutByUserID(
        localStorage.getItem(server.USER_ID),
        this.datefrom,
        this.dateto,
      );

      // 🔍 Debug: ดูข้อมูลที่ได้จาก API

      this.dataAll = resData.data;
      this.mDataArray = resData.data;


      this.$hideLoader();
    },
    async searchdata() {
      this.$showLoader();
      const resData = await api.getAllCheckInOutByUserID(
        localStorage.getItem(server.USER_ID),
        this.datefrom,
        this.dateto,
      );


      this.dataAll = resData.data;
      this.mDataArray = resData.data;
      this.page = 1;
      this.$hideLoader();
    },
    openPreviewMaps(data) {
      // ใช้ Regular Expression เพื่อดึงพิกัดจากข้อมูล
      const regex = /([\d.-]+)\s*,\s*([\d.-]+)/;
      const matches = data.match(regex);

      if (matches) {
        const lat = matches[1]; // ละติจูด (latitude)
        const lng = matches[2]; // ลองจิจูด (longitude)

        // สร้าง URL สำหรับเปิด Google Maps ที่จุดเดียว
        const url = `https://www.google.com/maps?q=${encodeURIComponent(
          lat,
        )},${encodeURIComponent(lng)}`;
        window.open(url, "_blank");
      } else {
        console.error("ไม่พบพิกัดในข้อมูล");
      }
    },
  },
};
